import {useAuth0} from '@auth0/auth0-react'
import {Menu} from '@mantine/core'
import {IconLogin, IconLogout} from '@tabler/icons-react'

export const AuthMenuItem = () => {
  const {user, isAuthenticated, logout, loginWithRedirect} = useAuth0()

  if (isAuthenticated)
    return (
      <>
        {user && <Menu.Label pb={0}>{user.name}</Menu.Label>}
        <Menu.Item leftSection={<IconLogout stroke={1} />} c={'red'} onClick={() => logout()}>
          Logout
        </Menu.Item>
      </>
    )

  return (
    <Menu.Item leftSection={<IconLogin stroke={1} />} onClick={() => loginWithRedirect()}>
      Login
    </Menu.Item>
  )
}
